/**
 * Field contract for Lagat receipt list filters (sources + labels).
 * Locked for characterization before shared ReceiptFilterLiveForm extract.
 */
export const LAGAT_RECEIPT_FILTER_FIELDS = [
  { source: "paymentMode", label: "Payment Mode", kind: "select" as const },
  { source: "q", label: "Search", kind: "text" as const },
  { source: "startDate", label: "Start Date", kind: "date" as const },
  { source: "endDate", label: "End Date", kind: "date" as const },
] as const;

export const LAGAT_RECEIPT_FILTER_SOURCES = LAGAT_RECEIPT_FILTER_FIELDS.map((f) => f.source);
